export interface GlobalSearchResultItem {
  id: string;
  idTwo: string;
  idThree: string;
  name: string;
  descriptionOne: string;
  descriptionTwo: string;
  createdOn: string;
  searchType: string;
}

export enum SearchMenuItem  {
  All="All",
  Projects="Projects",
  CadData="CadModels",
  Drawings="Drawings",
  BuildKits="BuildKits",
  Reports="Reports",
  Library="Library",
}
